import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import moment from 'moment';
import { MeasureService } from '../../measure.service';

//******************* */
@Component({
    selector: 'nio-date-range-picker',
    templateUrl: './date-range-picker.component.html',
    styleUrls: ['./date-range-picker.component.scss'],
    standalone: false
})
export class DateRangePickerComponent implements OnInit, OnChanges {
  @Input() chbxLabel;
  @Input() showMonthsOnly = false;
  @Input() isBillingTab = false;
  @Input() forceBillingDateOnly = false; // New input to force billing date only
  @Input() globalSelectedDateFilterType;
  @Output() selectedDatesChanged: EventEmitter<any> = new EventEmitter<any>();
  @Output() chbxStateChanged: EventEmitter<any> = new EventEmitter<any>();
  @Output() selecteDateFilterTypeChanged: EventEmitter<any> =
    new EventEmitter<any>();
  @Output() selectedBillingDateChanged: EventEmitter<any> =
    new EventEmitter<any>();
  datesForm: FormGroup;
  activeBtn = '';
  currentYear = new Date().getFullYear();
  today = new Date();
  disable = false;
  isDateRangeWrong = false;
  btnValues = [
    {
      label: 'January',
      startDate: `${this.currentYear}-01-01`,
      endDate: `${this.currentYear}-01-31`,
    },
    {
      label: 'February',
      startDate: `${this.currentYear}-02-01`,
      endDate: `${this.currentYear}-02-28`,
    },
    {
      label: 'March',
      startDate: `${this.currentYear}-03-01`,
      endDate: `${this.currentYear}-03-31`,
    },
    {
      label: 'April',
      startDate: `${this.currentYear}-04-01`,
      endDate: `${this.currentYear}-04-30`,
    },
    {
      label: 'May',
      startDate: `${this.currentYear}-05-01`,
      endDate: `${this.currentYear}-05-31`,
    },
    {
      label: 'June',
      startDate: `${this.currentYear}-06-01`,
      endDate: `${this.currentYear}-06-30`,
    },
    {
      label: 'July',
      startDate: `${this.currentYear}-07-01`,
      endDate: `${this.currentYear}-07-31`,
    },
    {
      label: 'August',
      startDate: `${this.currentYear}-08-01`,
      endDate: `${this.currentYear}-08-31`,
    },
    {
      label: 'September',
      startDate: `${this.currentYear}-09-01`,
      endDate: `${this.currentYear}-09-30`,
    },
    {
      label: 'October',
      startDate: `${this.currentYear}-10-01`,
      endDate: `${this.currentYear}-10-31`,
    },
    {
      label: 'November',
      startDate: `${this.currentYear}-11-01`,
      endDate: `${this.currentYear}-11-30`,
    },
    {
      label: 'December',
      startDate: `${this.currentYear}-12-01`,
      endDate: `${this.currentYear}-12-31`,
    },
    // {
    //   label: 'Last Week',
    //   startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'),
    //   endDate: moment().format('YYYY-MM-DD'),
    // },
    // {
    //   label: 'Last Month',
    //   startDate: moment().subtract(30, 'days').format('YYYY-MM-DD'),
    //   endDate: moment().format('YYYY-MM-DD'),
    // },
    // {
    //   label: 'Last 45 Days',
    //   startDate: moment().subtract(45, 'days').format('YYYY-MM-DD'),
    //   endDate: moment().format('YYYY-MM-DD'),
    // },
  ];
  otherbtnValues = [
    {
      label: 'Last 7 Days',
      startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'),
      endDate: moment().format('YYYY-MM-DD'),
    },
    {
      label: 'Last 30 Days',
      startDate: moment().subtract(30, 'days').format('YYYY-MM-DD'),
      endDate: moment().format('YYYY-MM-DD'),
    },
    {
      label: 'Last 45 Days',
      startDate: moment().subtract(45, 'days').format('YYYY-MM-DD'),
      endDate: moment().format('YYYY-MM-DD'),
    },
  ];
  selectedDateFilterType = 'usage_date';
  monthYearDate;
  constructor(private measureService: MeasureService) {}

  ngOnInit(): void {
    this.initForm();
    if (!this.showMonthsOnly) {
      this.otherbtnValues.forEach((val) => {
        this.btnValues.push(val);
      });
    }

    // If forceBillingDateOnly is true, set billing_date and select current month
    if (this.forceBillingDateOnly) {
      this.selectedDateFilterType = 'billing_date';
      this.datesForm.get('dateFilterType')?.setValue('billing_date');
      // Set current month as default
      const currentMonth = moment().startOf('month'); // Get first day of current month
      this.monthYearDate = currentMonth.format('MM/YYYY');
      this.datesForm.get('monthYearDate')?.setValue(currentMonth);
      // Emit the current month selection (first day of month)
      setTimeout(() => {
        this.selecteDateFilterTypeChanged.emit('billing_date');
        this.selectedBillingDateChanged.emit(currentMonth.format('YYYY-MM-DD'));
      }, 0);
    }
  }

  initForm() {
    this.datesForm = new FormGroup({
      startDate: new FormControl(),
      endDate: new FormControl(),
      dateFilterType: new FormControl(),
      monthYearDate: new FormControl(moment()),
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    // If forceBillingDateOnly is true, ALWAYS keep billing_date regardless of global changes
    if (this.forceBillingDateOnly) {
      this.selectedDateFilterType = 'billing_date';
      this.datesForm?.get('dateFilterType')?.setValue('billing_date');

      // Set current month if not already set
      if (!this.monthYearDate) {
        const currentMonth = moment().startOf('month');
        this.monthYearDate = currentMonth.format('MM/YYYY');
        this.datesForm?.get('monthYearDate')?.setValue(currentMonth);
      }
    } else if (this.globalSelectedDateFilterType) {
      // Only apply global date filter type if NOT in forceBillingDateOnly mode
      this.selectedDateFilterType = this.globalSelectedDateFilterType;
      this.datesForm
        ?.get('dateFilterType')
        .setValue(this.globalSelectedDateFilterType);
    }
  }

  dateChanged() {
    let formattedStartDate;
    let formattedendtDate;

    this.activeBtn = '';

    if (this.datesForm.value.startDate) {
      formattedStartDate = moment(this.datesForm.value.startDate).format(
        'YYYY-MM-DD'
      );
    }

    if (this.datesForm.value.endDate) {
      formattedendtDate = moment(this.datesForm.value.endDate).format(
        'YYYY-MM-DD'
      );
    }

    if (this.datesForm.value.startDate && this.datesForm.value.endDate) {
      if (this.datesForm.value.startDate <= this.datesForm.value.endDate) {
        this.selecteDateFilterTypeChanged.emit(this.selectedDateFilterType);
        this.selectedDatesChanged.emit({
          startDate: formattedStartDate || '',
          endDate: formattedendtDate || '',
        });
        this.isDateRangeWrong = false;
      } else {
        this.isDateRangeWrong = true;
        console.log('Dates Not Equal >> ');
      }
    }
  }

  quickDateSelection(event, btnValue) {
    if (btnValue) {
      this.datesForm.get('startDate').setValue(btnValue?.startDate);
      this.datesForm.get('endDate').setValue(btnValue?.endDate);
    }

    event.stopPropagation();
    this.datesForm.reset();
    this.datesForm.get('dateFilterType').setValue('usage_date');
    // this.monthYearDate = null;
    this.selecteDateFilterTypeChanged.emit('usage_date');
    this.activeBtn = btnValue.label;

    this.selectedDatesChanged.emit({
      startDate: btnValue.startDate,
      endDate: btnValue.endDate,
    });
  }

  chbxChanged(event) {
    if (event.checked) {
      this.disable = true;
      this.datesForm.disable();
    } else {
      this.disable = false;
      this.datesForm.enable();
    }

    this.chbxStateChanged.emit(event.checked);
  }
  dateFilterTypeChanged(event) {
    // If forceBillingDateOnly is true, prevent changing to usage_date
    if (this.forceBillingDateOnly) {
      this.selectedDateFilterType = 'billing_date';
      this.datesForm.get('dateFilterType').setValue('billing_date');
      return;
    }

    this.selectedDateFilterType = event.value;
    this.datesForm.get('dateFilterType').setValue(this.selectedDateFilterType);
  }

  setMonthAndYear(normalizedMonthAndYear, datepicker) {
    const monthYearValueForDisplay = moment(normalizedMonthAndYear).format(
      'MM/YYYY'
    );
    // Get the first day of the selected month for API
    const monthYearValueForAPI = moment(normalizedMonthAndYear)
      .startOf('month')
      .format('YYYY-MM-DD');
    // console.log('@setMonthAndYear >> monthYearValueForDisplay >> ', monthYearValueForDisplay);
    // console.log('@setMonthAndYear >> monthYearValueForAPI >> ', monthYearValueForAPI);
    this.monthYearDate = monthYearValueForDisplay;
    datepicker.close();
    this.selecteDateFilterTypeChanged.emit(this.selectedDateFilterType);
    this.selectedBillingDateChanged.emit(monthYearValueForAPI);
  }
}
